import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { DeviceControlContext } from '../../DeviceControlContext';
import { useContext } from 'react';
import { IoTVAccordion, IoTVAccordionDetails, IoTVAccordionSummary } from '../../../../../../../components/common/IoTVAccordion';
export const UnknownAttributeControl = ({ state, dispatch, stateKey: key, label, maxWidth, reported }) => {
    const { valueSettings, payloadRequestObject, validationMap } = state;
    const { state: DeviceControlContextState, dispatch: DeviceControlDispatch } = useContext(DeviceControlContext);
    const { rangeLimits, resolvedDownlinkAttributes, correspondingUplinkAttributeMap } = DeviceControlContextState;
    const subRangeLimits = rangeLimits?.[key];
    const mapValidation = validationMap[key] ?? {};
    const correspondingUplinkKey = correspondingUplinkAttributeMap?.[key] ?? key;
    const rawReportedValue = reported?.[correspondingUplinkKey];
    if (!valueSettings[key]) {
        return _jsx(Typography, { children: `Can't find key ${key}` });
    }
    else
        return (_jsxs(Stack, { direction: 'column',
            alignItems: 'center',
            gap: 1,
            width: maxWidth,
            boxSizing: 'border-box',
            paddingInline: 1.5,
            borderRadius: 1,
            border: (t) => `1px solid ${t.palette.action.disabled}`,
            sx: {
                [`&:hover`]: {
                    border: (t) => `1px solid ${t.palette.action.active}`,
                },
            }, children: [_jsxs(IoTVAccordion, { children: [_jsx(IoTVAccordionSummary, { children: _jsx(Typography, { paddingBlock: 1, sx: { maxWidth }, children: label }) }), _jsxs(IoTVAccordionDetails, { children: [_jsx(Typography, { paddingBlock: 1, sx: { maxWidth }, children: key }), _jsx(Typography, { paddingBlock: 1, sx: { maxWidth }, children: JSON.stringify(valueSettings?.[key], null, 1) }), _jsx(Typography, { paddingBlock: 1, sx: { maxWidth }, children: JSON.stringify(subRangeLimits?.[key], null, 1) })] })] }), _jsxs(Typography, { children: ["(", _jsx(Typography, { component: "span", sx: { fontStyle: 'italic' }, children: "Reported" }), ": ", rawReportedValue ?? 'N/A', ")"] })] }));
};
